// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabPanel_layersCustom__lBTgL h2 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  font-size: 13px !important;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor/components/TabPanel/TabPanel.module.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,gBAAA;AAAJ","sourcesContent":[".layersCustom {\n  h2 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n    font-size: 13px !important;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layersCustom": `TabPanel_layersCustom__lBTgL`
};
export default ___CSS_LOADER_EXPORT___;
